import { render, staticRenderFns } from "./demandInfo.vue?vue&type=template&id=05d146ae"
import script from "./demandInfo.vue?vue&type=script&lang=js"
export * from "./demandInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports